import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useHistory, useParams } from "react-router-dom";

import "./home-list.scss";
import { Loading } from "../../components/shared/index";
import ArticleCard from "./ArticleCard";
import FilterList from "./FilterList";
import lockImg from "../../images/lock.png";
import emptyImg from "../../images/empty.png";
import threeLines from "../../images/three-lines-icon.svg";
import authStore from "../../stores/authStore";
import articleStore from "../../stores/articleStore";
import { triggerLogin } from "../../utils/trigger";
import { isMobile } from "../../utils/tools";
import { message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

interface Props {
  type?: string;
}

const HomeList: React.FC<Props> = (props: Props) => {
  const history = useHistory();
  const { id } = useParams();
  const { type = "list" } = props;
  const [activeId, setActiveId] = useState("");
  const [conHeight, setConHeight] = useState<string | number>("0");
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const container = document.querySelector(`.detail__content`);
  const { isLogin, isMember, setDialog } = useContext(authStore);
  const {
    fetchList,
    nextPage,
    list,
    loading,
    pagination,
    keyword,
    showList,
    setShowList,
    articlesCount,
  } = useContext(articleStore);
  const onScrollEvent = () => {
    if (isLogin && isMember && !loading && pagination.hasNextPage) {
      const dom = document.getElementsByClassName("home__list-scroll")[0];
      if (
        dom.scrollTop + dom.clientHeight > dom.scrollHeight * 0.95 &&
        list.length < pagination.total
      ) {
        nextPage(keyword);
      }
    }
  };

  useEffect(() => {
    setActiveId("");
  }, []);

  useEffect(() => {
    container && setConHeight(`${container.clientHeight}px`);
  }, [container]);

  useEffect(() => {
    id && setActiveId(id);
  }, [id]);

  return (
    <div
      className={`home__list-wrapper ${activeId &&
        !showList &&
        "home__list-wrapper--fold"}`}
      style={activeId && showList ? { height: conHeight } : {}}
      onClick={(e: React.BaseSyntheticEvent) => e.stopPropagation()}
    >
      {keyword ? (
        <div className="home__filter">
          <div className="home__filter-total">
            共找到 <span>{pagination.total}</span> 篇文章
          </div>
          <FilterList onFilterChange={() => fetchList(keyword)} />
        </div>
      ) : (
        type === "detail" && (
          <div
            className="home__list-btn"
            onClick={() => {
              // 没滚到位，二次再滚一下---------- start
              const jumpType = window.sessionStorage.getItem("jumpType");
              const activeEl = document.querySelector(
                ".article-card--active"
              ) as HTMLElement;
              const scrollEl = document.querySelector(
                ".home__list-scroll"
              ) as HTMLElement;
              if (jumpType && jumpType === "home" && activeEl && scrollEl) {
                scrollEl.scrollTop = activeEl.offsetTop;
                window.sessionStorage.removeItem("jumpType");
              }
              // 没滚到位，二次再滚一下---------- end
              setShowList(!showList);
            }}
          >
            <img src={threeLines} alt="icon" />
            {showList ? "收起列表" : "展开列表"}
          </div>
        )
      )}
      <div
        className={`home__list-scroll ${activeId &&
          !showList &&
          "home__list-scroll--none"} ${keyword && "home__list-scroll--low"}`}
        id="home__list"
        onScrollCapture={onScrollEvent}
      >
        <div className={`home__list ${activeId && "home__list--detail"}`}>
          {list && list.length > 0 && (
            <div
              className="hover-block"
              style={loading ? { backgroundColor: "#fff" } : {}}
            />
          )}
          {list && list.length > 0
            ? list.map((item, index) => (
              <ArticleCard
                activeId={activeId}
                key={item.id}
                slug={item.slug}
                index={index}
                hoveredIndex={hoveredIndex}
              >
                <div
                  className={`home__list__article ${(!isLogin || !isMember) &&
                    "home__list__article--disabled"}`}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => {
                    if (isLogin && isMember) {
                      window.sessionStorage.setItem(
                        "articlePath",
                        window.location.pathname
                      );
                      if (!id) {
                        window.sessionStorage.setItem("jumpType", "list");
                      }
                      setActiveId(item.slug);
                      history.push(`/${item.slug}`);
                    } else {
                      if (isLogin) {
                        message.warning({
                          content: "请先订阅文章库，方可解锁检索功能",
                          icon: <ExclamationCircleFilled style={{ color: "#faad14" }} />,
                        });
                      } else {
                        triggerLogin();
                      }
                    }
                  }}
                >
                  <div className="article-card__left">
                    <div className="article-card__title">{item.title}</div>
                    {/* <div className="article-card__content">
                        {item.content}
                      </div> */}
                    <div className="article-card__bottom">
                      <div className="article-card__time">
                        {item.publishTime}
                      </div>
                      {!isMobile() &&
                        item.tagList &&
                        item.tagList.length > 0 && (
                          <div className="article-card__tags">
                            {activeId ? (
                              <div>{item.tagList[0]}</div>
                            ) : (
                              item.tagList.map(
                                (item: string, index: number) => (
                                  <div key={index}>{item}</div>
                                )
                              )
                            )}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="article-card__right">
                    <img src={item.coverImageUrl} alt="img" />
                  </div>
                </div>
              </ArticleCard>
            ))
            : !loading && (
              <div className="home__list__empty">
                <img src={emptyImg} alt="empty" />
                <p>没有找到你要的内容</p>
                <div>你可以换一个词重新搜索</div>
              </div>
            )}
          {loading && <Loading />}
        </div>
      </div>
      {/* 引导登录 ｜ 订阅会员 */}
      {((type === "detail" && showList) || type === "list") &&
        (!isLogin || !isMember) && (
          <div className="home__list__login">
            {isLogin ? (
              <div className="home__list__login-words home__list__lock-words">
                <img src={lockImg} alt="lock" />
                {articlesCount
                  ? `订阅文章库，解锁 ${articlesCount} 篇文章及后续更新`
                  : ""}
              </div>
            ) : (
              <div className="home__list__login-words">
                已订阅文章库？点此{" "}
                <span onClick={() => triggerLogin()}>登录</span>
              </div>
            )}
            <div
              className="home__list__login-btn"
              onClick={() => {
                if (isLogin) {
                  setDialog("buyVip", true);
                } else {
                  triggerLogin();
                }
              }}
            >
              {isLogin
                ? "立即订阅"
                : articlesCount
                  ? `订阅文章库，解锁 ${articlesCount} 篇文章阅读`
                  : ""}
            </div>
          </div>
        )}
    </div>
  );
};

export default observer(HomeList);
